import { StyleSheet } from "react-native";
export const getStyles = (theme) => {
    const { colors, space, shadows } = theme;
    return StyleSheet.create({
        container: {
            ...shadows[6]
        }
    });
};
